module.exports = __webpack_public_path__ + "img/om.7be3adc2.jpg";